import ReactTooltip from 'react-tooltip';
import styled from 'styled-components';

const StyledTooltip = styled(ReactTooltip)`
  max-width: 250px;
  white-space: normal;
`;

const Tooltip = ({ ...props }: any) => (
  <StyledTooltip effect="solid" multiline place="top" {...props} />
);

export default Tooltip;
